const UseStorage = () => {
    const test = 'test'

    return {
        test
    };
};

export default UseStorage;